import React, { useRef } from 'react';

import { SkeletonLoading } from '@saleshandy/design-system';
import Select from '../../../design-system/components/select';

import { TimezoneDropdownOption } from '../types';
import { getIsRequestPending, getTimezoneList } from '../../../utils';
import { RequestStatus } from '../../../enums/request-status';
import {
  OverlayTooltip,
  Placement,
} from '../../../design-system/components/overlay';

type IProps = {
  selectedTimezone: TimezoneDropdownOption;
  setSelectedTimezone: (timezone: TimezoneDropdownOption) => void;
  isSequenceTimezone: boolean;
  getSequenceTimezoneRequestStatus: RequestStatus;
  sequenceTimezone: string;
};

const TimezoneDropdown: React.FC<IProps> = ({
  selectedTimezone,
  setSelectedTimezone,
  isSequenceTimezone,
  getSequenceTimezoneRequestStatus,
  sequenceTimezone,
}) => {
  const getTimeZoneOptions = () => {
    const timeZones = getTimezoneList();
    return timeZones.map((item) => ({
      key: item.name,
      ...item,
    }));
  };

  return (
    <div className="schedule-reply-modal--content-wrapper timezone-wrapper">
      <p className="schedule-reply-modal--content-label">Time zone</p>
      {getIsRequestPending(getSequenceTimezoneRequestStatus) ? (
        <SkeletonLoading height={32} width={396} />
      ) : (
        <Select<TimezoneDropdownOption>
          showSearch
          className="timezone-dropdown-select"
          placeholder="Select Time zone"
          options={getTimeZoneOptions()}
          selectedOptionKey={selectedTimezone?.key || null}
          optionRenderer={(option) => {
            if (option?.name === sequenceTimezone) {
              return (
                <OverlayTooltip
                  text="Sequence Timezone"
                  placement={Placement.Bottom}
                >
                  <div>
                    <span>
                      {option?.value}
                      <p className="m-0 font-10 font-italic gray-txt-11">
                        (Sequence Timezone)
                      </p>
                    </span>
                  </div>
                </OverlayTooltip>
              );
            }
            return (
              <span>
                {option?.value}
              </span>
            );
          }}
          onChange={([selectedOption]) => {
            setSelectedTimezone(selectedOption);
          }}
          filterOption={(value, option) =>
            option.name.toLowerCase().includes(value.toLowerCase())
          }
          selectedOptionRenderer={([option]) => (
            <div className="selected-timezone">
              <span className="timezone-value">{option?.value}</span>
              {isSequenceTimezone && (
                <span className="sequence-timezone-label">
                  Sequence Timezone
                </span>
              )}
            </div>
          )}
        />
      )}
    </div>
  );
};

export default TimezoneDropdown;
